<template>
  <div class="notify-notice-backdrop">
    <div class="notify-notice" role="dialog" aria-modal="true" :aria-label="t('notify-notice-title')">
      <h3>{{ t('notify-notice-title') }}</h3>
      <p>{{ t('notify-notice-when') }}<b>{{ t('notify-notice-watching') }}</b></p>
      <p>{{ t('notify-notice-how') }}</p>
      <p>{{ t('notify-notice-settings') }}</p>
      <p class="warning">{{ t('notify-notice-warning') }}</p>
      <ActionButton class="btn-main notice-on" :label="t('notify-notice-on')" :action="on" variant="switch" :collect="true" :disabled="busy" @result="r => (result = r)" />
      <button type="button" class="btn-secondary notice-off" :disabled="busy" @click="off">{{ t('notify-notice-off') }}</button>
    </div>
  </div>
</template>
<script>
// The reminder notice (plan 2026-10-22-notification-notice-and-templates): explains reminders before
// WeChat is first asked for permission, and whenever the player turns them back on. 开启提醒 is the
// one button that asks WeChat (its 'switch' variant collects while the preference isn't on); a
// 取消 in WeChat's popup turns reminders off, since none could arrive. Emits `close` once answered.
import api from '@/api/api';
import ActionButton from '@/components/ActionButton';
import { noticeState } from './notice';
import { t } from '@/texts';

export default {
  components: { ActionButton },
  data: () => ({ busy: false, result: null }),
  methods: {
    t,
    async set(notify) {
      this.busy = true;
      try {
        const user = await api.call('PATCH', `users/${this.$store.state.user.id}`, { notify });
        this.$store.commit('set', { user });
      } finally { this.busy = false; }
    },
    async on() {
      const rejected = this.result === 'reject';
      this.result = null;
      await this.set(!rejected);
      noticeState.rejected = rejected;
      this.$emit('close');
    },
    async off() {
      await this.set(false);
      noticeState.rejected = false;
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
.notify-notice-backdrop { position: fixed; inset: 0; z-index: 50; display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, 0.45); }
.notify-notice { box-sizing: border-box; width: calc(100% - 36px); max-width: 400px; padding: 20px 18px 14px; border-radius: 12px; background: #fff; color: #2c3e50; text-align: left; font-size: 15px; line-height: 1.55; }
.notify-notice h3 { margin: 0 0 12px; text-align: center; font-size: 18px; }
.notify-notice p { margin: 0 0 8px; }
.notify-notice .warning { margin-bottom: 14px; color: #c0392b; }
.notify-notice .notice-on, .notify-notice .notice-off { display: block; width: 100%; height: 46px; margin: 0 0 10px; font-size: 17px; }
</style>
